import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService, ConfigStorage, ENVIRONMENT, LoginComponentBase, PRE_AUTH_SERVICE, PreAuthService } from '@scisys-uim/uim-common';
import { LoginFailedDialogComponent } from './dialog/login-failed-dialog.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends LoginComponentBase {

  bannerImageAssetPath: string;
  fcItEmail: string;
  fcItSubject: string;
  fcItBody: string;

  constructor(
    protected authService: AuthService,
    @Inject(PRE_AUTH_SERVICE) protected preAuthServices: PreAuthService[],
    @Inject(ENVIRONMENT) protected environment: any,
    protected configService: ConfigStorage,
    protected dialog: MatDialog) {
    super(authService, preAuthServices, environment, configService, dialog);
    this.bannerImageAssetPath = this.environment?.bannerImageAssetPathDefault;

    this.fcItEmail = "operationsadmin@forestryengland.uk";
    this.fcItSubject = "eAssetsr%20Account%20Creation%20Request";
    this.fcItBody = "Please%20can%20I%20request%20a%20new%20eAssets%20user account.%0A%0AUsername:%0AForest%20District:%0ARole:%0ALine%20Manager:%0A%0A**%20Please%20CC%20the%20email%20to%20your%20line%20manager%20for%20approval.%0A%0AThanks,"
  }

  openFailedLoginDialog(error: any): void {
    this.dialog.open(LoginFailedDialogComponent, {
      panelClass: 'dialog-resizable',
      width: '250px',
      data: this.getFailedLoginDialogData(error)
    });
  }


  getFailedLoginDialogData(error: any) {
    return { title: 'Failed Login', message: null, error: error };
  }
}
